import { deepMerge, update } from '@adalo/utils'

import getObject from '../objects/getObject'
import InstructionState from '../types/InstructionState'
import { ObjectList } from '../types/ObjectList'

export interface UpdateElementOptions {
  objectId: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  changes: any
}

export interface UpdateElementInstruction {
  operation: 'updateElement'
  options: UpdateElementOptions
}

export const updateElementHandler = (
  state: InstructionState,
  options: UpdateElementOptions
): InstructionState => {
  const { list, pathMap } = state
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { objectId, changes } = options

  return {
    ...state,
    list: update(
      list,
      pathMap[objectId],
      deepMerge(getObject(list, pathMap, objectId), changes)
    ) as ObjectList,
  }
}

const updateElement = (
  objectId: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  changes: any
): UpdateElementInstruction => ({
  operation: 'updateElement',
  options: {
    objectId,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    changes,
  },
})

export default updateElement
